import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  bankingOnlyTitle: {
    id: "funding-application: incomplete steps modal banking title",
    defaultMessage: "Add banking data to submit",
  },
  bankingOnlyBody: {
    id: "funding-application: incomplete steps modal banking body",
    defaultMessage:
      "We use banking data to assess your application. Connect your bank or upload statements to continue.",
  },
  bankingOnlyCta: {
    id: "funding-application: incomplete steps modal banking cta",
    defaultMessage: "Add banking data",
  },
  platformsOnlyTitle: {
    id: "funding-application: incomplete steps modal platforms title",
    defaultMessage: "You're missing required connections",
  },
  platformsOnlyBody: {
    id: "funding-application: incomplete steps modal platforms body",
    defaultMessage:
      "To process your application, we need an accounting platform connected or accounting documents uploaded. Connect or upload before submitting.",
  },
  platformsOnlyCta: {
    id: "funding-application: incomplete steps modal platforms cta",
    defaultMessage: "Go back and connect",
  },
  multiTitle: {
    id: "funding-application: incomplete steps modal multi title",
    defaultMessage: "Before you submit",
  },
  multiBody: {
    id: "funding-application: incomplete steps modal multi body",
    defaultMessage:
      "We need more information to assess your application and build your offer. To continue, you still need to:",
  },
  addBankingData: {
    id: "funding-application: incomplete steps add banking",
    defaultMessage: "Add banking data",
  },
  connectPlatforms: {
    id: "funding-application: incomplete steps connect platforms",
    defaultMessage: "Connect your platforms",
  },
  completeCreditCheck: {
    id: "funding-application: incomplete steps credit check",
    defaultMessage: "Complete soft credit check",
  },
  connectBankAccountCta: {
    id: "funding-application: incomplete steps connect bank cta",
    defaultMessage: "Connect bank account",
  },
  connectPlatformsCta: {
    id: "funding-application: incomplete steps connect platforms cta",
    defaultMessage: "Connect platforms",
  },
  completeCreditCheckCta: {
    id: "funding-application: incomplete steps credit check cta",
    defaultMessage: "Complete credit check",
  },
  uploadDocumentCta: {
    id: "funding-application: incomplete steps upload document cta",
    defaultMessage: "Upload document",
  },
});

export const DOCUMENT_NAMES = defineMessages({
  susa: {
    id: "funding-application: document name susa",
    defaultMessage: "SuSa",
  },
  "pool-bancario": {
    id: "funding-application: document name pool bancario",
    defaultMessage: "Pool Bancario",
  },
  "management-accounts": {
    id: "funding-application: document name management accounts",
    defaultMessage: "Management Accounts",
  },
  "profit-and-loss": {
    id: "funding-application: document name profit and loss",
    defaultMessage: "Profit and Loss",
  },
  "balance-sheet": {
    id: "funding-application: document name balance sheet",
    defaultMessage: "Balance Sheet",
  },
  "debt-agreement": {
    id: "funding-application: document name debt agreement",
    defaultMessage: "Debt Agreements",
  },
  "cash-flow-forecast": {
    id: "funding-application: document name cash flow forecast",
    defaultMessage: "Revenue Projections",
  },
});

export const DOCUMENT_TEMPLATES = defineMessages({
  uploadLabel: {
    id: "funding-application: incomplete steps upload document label",
    defaultMessage: "Upload {documentName}",
  },
  inlineError: {
    id: "funding-application: document inline error",
    defaultMessage: "Upload your {documentName} to continue. We need it to build your offer.",
  },
});
